export const getLabelStyle = (isActive, theme, activeTabColor) => {
    let color = theme.textMuted;
    if (isActive) {
        color = activeTabColor || theme.brand;
    }
    return { color };
};
